import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { PageHeader } from "@/components/PageHelpers";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { BellRing } from "lucide-react";

export default function NotificationsPage() {
  const [items, setItems] = useState([]);
  const load = async () => { const { data } = await api.get("/notifications"); setItems(data.items); };
  useEffect(() => { load(); }, []);
  const markRead = async (id) => { await api.patch(`/notifications/${id}/read`); load(); };
  return (
    <div>
      <PageHeader eyebrow="Inbox" title="Notifications" subtitle="Everything the platform is telling you." />
      <div className="space-y-3">
        {items.map((n) => (
          <Card key={n.id} className={"border-white/10 bg-card p-4 flex items-start gap-3 " + (!n.read ? "ring-1 ring-orange-500/20" : "")} data-testid={`notif-${n.id}`}>
            <div className="h-9 w-9 rounded-md bg-orange-500/10 border border-orange-500/30 flex items-center justify-center shrink-0">
              <BellRing className="h-4 w-4 text-orange-400" />
            </div>
            <div className="flex-1 min-w-0">
              <div className="text-sm font-medium">{n.title}</div>
              <div className="text-xs text-zinc-500">{n.body}</div>
              <div className="text-[10px] uppercase tracking-widest text-zinc-600 mt-1">{n.type}</div>
            </div>
            {!n.read && <Button size="sm" variant="outline" onClick={() => markRead(n.id)} data-testid={`notif-read-${n.id}`} className="border-white/10">Mark read</Button>}
          </Card>
        ))}
        {items.length === 0 && <div className="text-sm text-muted-foreground">All caught up.</div>}
      </div>
    </div>
  );
}
